import Form from './components/App';
import reducer from './reducers';
import prepareFormForSubmit from './lib/prepareFormForSubmit';
import { validateForm } from './lib/validation';
import { highlightErrors, clearFormValues, onFormChange } from './actions/form';
import createInitialState from './lib/createInitialState';
import didFormChange from './lib/didFormChange';

export default {
  Form,
  reducer,
  actions: { highlightErrors, clearFormValues, onFormChange },
  utils: {
    prepareFormForSubmit,
    validateForm,
    createInitialState,
    didFormChange,
  },
};
